import { Menu, MenuProps } from 'antd'

export interface KBMenuProps extends MenuProps {}

export function KBMenu(props: MenuProps) {
  return <Menu {...props} />
}

KBMenu.Item = Menu.Item
